import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { PortalAccessCard } from '../PortalAccessCard';
import { isConsolidatorRecord } from './ClientRecordHeader';
import { useCanManageFleetClients, useClientRecord } from './client-record-data';

export const Route = createFileRoute('/console/$orgId/configuration/fleet/client-database/details/$id/portal-access')({
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <PortalAccessTab />
        </PageController>
    );
}

function PortalAccessTab() {
    const { id } = Route.useParams();
    const { data: client } = useClientRecord(id);
    const canEdit = useCanManageFleetClients();

    if (!client) {
        return null;
    }

    // A client lists its fleet managers; a consolidator its coordinators (CUR-1099).
    return (
        <PortalAccessCard
            fleetClientId={client.id}
            attachment={isConsolidatorRecord(client) ? 'CONSOLIDATOR' : 'CLIENT'}
            canEditAuthority={canEdit}
        />
    );
}
